import { ApiEnum } from "../../constants/ApiEnum";
import axios, { AxiosResponse } from "axios";
import { UpdateArgs } from "../../interfaces/DossierInterface";
import { disableApiError, setDossierApiError } from "../../../app/rootReducer";
import { Dispatch } from "redux";

interface ApiDossierUpdateData {
    data: {
        status: {
            message: object;
        };
    };
}

export const ApiDossierUpdate = async (
    dossierId: number,
    dossierAccessToken: string,
    dispatch: Dispatch,
    args?: UpdateArgs,
): Promise<AxiosResponse<ApiDossierUpdateData>> => {
    return await axios
        .patch(ApiEnum.DOSSIER + "/update", {
            dossierId: dossierId,
            dossierAccessToken: dossierAccessToken,
            data: args?.data,
            method: args?.method,
        })
        .then(function (response) {
            dispatch(disableApiError());
            return response;
        })
        .catch(function (error) {
            dispatch(setDossierApiError(error.response.status));
            return error;
        });
};
